import { all, call } from "redux-saga/effects";

//import watchDepositTicketSaga from "./deposit-ticket";

export function* depositTicketSaga() {
	yield all([
		//call(watchDepositTicketSaga),
	]);
}
